import { Sort } from '@/providers/turn/types';

export const PER_PAGE = 100;

export const SORT_OPTIONS: Sort = { field: 'name', order: 'ASC' };
